import { create } from 'zustand';

interface AuditStepUpState {
  audit_token: string | null;
  expires_at_ms: number | null;
  setToken: (token: string, expires_in_seconds: number) => void;
  clear: () => void;
  /** Returns the token if still within the cached TTL window, else null. */
  getActiveToken: () => string | null;
}

/** In-memory only — never persisted, never logged. */
export const useAuditStepUpStore = create<AuditStepUpState>((set, get) => ({
  audit_token: null,
  expires_at_ms: null,
  setToken: (token, expires_in_seconds) =>
    set({ audit_token: token, expires_at_ms: Date.now() + expires_in_seconds * 1_000 }),
  clear: () => set({ audit_token: null, expires_at_ms: null }),
  getActiveToken: () => {
    const { audit_token, expires_at_ms } = get();
    if (!audit_token || !expires_at_ms) return null;
    if (Date.now() >= expires_at_ms) return null;
    return audit_token;
  },
}));
